import { createFileRoute } from '@tanstack/react-router'
import { requireAdmin } from '@/lib/auth-guards'
import { QrCheckInPage } from '@/features/check-ins/qr-checkin-page'

export const Route = createFileRoute('/_authenticated/check-ins/qr')({
  beforeLoad: requireAdmin,
  component: QrCheckInPage,
})
